export enum PropertyType {
  PARENT_TABLE = 'Parent Table',
  FPK = 'Functional Primary Key',
  WORKFLOW_ACTOR = 'Workflow Actor',
  LOOKUP_FIELDS = 'Lookup Fields',
  COMPOSITE_DATATYPE = 'Composite Data Type',
  LOOKUP = 'Lookup',
  IMPORT = 'Import',
  SEARCHABLE = 'Searchable Fields',
  EXPORT = 'Export',
  MANDATORY_INPUT_FILTERS = 'Madatory Input Filters',
  EXPORT_ROLES = 'Export Roles',
  EXPORT_FILTER = 'Export Filter',
  IMPORT_ROLES = 'Import Roles',
  WORKFLOW_ACTION = 'Workflow Action',
  LOOKUP_OPTIONAL_FILTERS = ' Lookup Optional Filters',
  LOOKUP_DISPLAY_FIELD = 'Lookup Display Field',
  LOOKUPTO_DISPLAY_FIELD = 'Display Field',
  LOOKUP_TO = 'Lookup To',
  EXPORT_FIELDS = 'Export Fields',
  EXPORT_FILTERS = 'Export Filters',
  LOOKUP_MANDATORY_FILTERS = 'Lookup mandatory filters',
  QUERY_BUILDER = 'Query builder',
  ROLE_FIELD = 'Role field',
  TABLE_OF_SERVICE = 'Table of service',
  ALLOWED_ROLES_FOR_SERVICES = 'Allowed roles for services',
  IMPORT_FIELDS = 'Import fields',
  OPTIONAL_FILTER = 'Optional filter',
  INDEX = 'Index',
  FOREIGN_KEY = 'Foreign key',
  FOREIGN_KEY_PARENT_INDEX = 'Foreign key parent index',
  WORKFLOW_ACTOR_ENABLED_FIELDS = 'Fields To Be Enabled',
  WORKFLOW_ACTOR_HIDDEN_FIELDS = 'Fields To Be Hidden',
  WORKFLOW_ACTOR_SHOW_FIELDS = 'Fields To Be Shown',
  WORKFLOW_ACTOR_DISABLED_FIELDS = 'Fields To Be Disabled',
  LOOKUPTO_FILTER_INPUT_MAPPING_FIELDS = 'Lookup Filter Input Mapping',
  LOOKUP_OUTPUT_MAPPING_FIELDS = 'Lookup Output Mapping',
  WORKFLOW_ACTION_NEXT_STATUS = 'Next status',
  WORKFLOW_ACTION_NEXT_ACTOR = 'Next actor',
  WORKFLOW_ACTOR_HIDDEN_ACTION = 'Actions To Be Hidden',
  WORKFLOW_ACTOR_SHOW_ACTION = 'Actions To Be Shown',
  WORKFLOW_ACTOR_DISABLED_ACTION = 'Actions To Be Disabled',
  WORKFLOW_ACTOR_ENABLED_ACTION = 'Actions To Be Enabled',
  WORKFLOW_ACTION_MANDATORY_FIELDS = 'Mandatory fields',
  WORKFLOW_HISTORY_BUTTON = 'Workflow history button',
  WORKFLOW_ACTION_BUTTON = 'Workflow action button',
  WORKFLOW_ACTION_SERVICE = 'Workflow action service',
  WORKFLOW_TABLE = 'Workflow table',
  WORKFLOW_FIELDS_VALUES = 'Workflow fields values',
  WORKFLOW_MAIL_TO = 'Workflow mail to',
  WORKFLOW_MAIL_CC = 'Workflow mail CC',
  NAVIGATION_DETAIL_PAGE = 'Detail page',
  NAVIGATION_PAGE = 'Navigation page',
  DEFAULT_SORT_ON = 'Default sort on',
  GROUP_ON_COLUMN = 'Group on column',
  GROUPS_ON_COLUMN = 'Group By Fields',
  TABLE_SEARCH = 'Table search',
  QUICK_FILTERS = 'Quick filters',
  CAPTION_BAR = 'Caption bar',
  TABLE = 'Table',
  FORM = 'Form',
  BQ_DATASET_VALUE = 'Bq dataset value',
  MANDATORY_CONDITIONAL = 'Mandatory on condition',
  EDIT_CONDITIONAL = 'Editable On Condition',
  VIEW_CONDITIONAL = 'Viewable On Condition',
  BUTTON_ENABLED_CONDITIONAL = 'Condition For Button Enable',
  BUTTON_VISIBILITY_CONDITIONAL = 'Condition For Button Visibility',
  SERVICE = 'Service',
  TABLE_PAGE = 'Table page',
  QUERY_PAGE = 'Table page',
  QUERY_VIEW_MULTIPLE_DETAIL_PAGE = 'Table page',
  WORKFLOW_ACTOR_STEP = 'Workflow actor',
  WORKFLOW_ACTION_STEP = 'Workflow action',
  WORKFLOW_FIELD = 'Workflow Field',
  WORKFLOW_ACTOR_STEP_FROM_STATUS = 'Workflow actor step from status',
  WORKFLOW_ACTION_STEP_FROM_STATUS = 'Workflow action step from status',
  WORKFLOW_ACTOR_STEP_FROM_ACTOR = 'Workflow actor step from actor',
  WORKFLOW_MAIL = 'Workflow mail',
  WORKFLOW_SERVICE = 'Workflow service',
  EXPORT_MAIL = 'Export mail',
  IMPORT_MAIL = 'Import mail',
  EXPORT_MAIL_TO = 'Export mail to',
  IMPORT_MAIL_CC = 'Import mail CC',
  EXPORT_MAIL_CC = 'Export mail CC',
  IMPORT_MAIL_TO = 'Import mail to',
  UNIQUE_IDENTIFIER = 'Unique identifier',
  DATA_POPULATION_STRATEGY = 'Field value reference',
  DATA_POPULATION_STRATEGY_FOREIGN_KEY = 'Field Reference - Foreign Key',
  DATA_POPULATION_STRATEGY_FIELD = 'Field Value Reference - foreign key field',
  ACCESS_CONTROL = 'Access Control',
  ALIGN_COLUMNS = 'Align columns',
  FORMULA_BUILDER = 'Formula',
  USERSTORY_ROLES = 'User Story Roles',
  TRANSACTION_TABLE = 'Transactional Table',
  DEFAULT_DATASET = 'Default Dataset',
  INDEX_DEFINITION = 'Index',
  CUSTOM_ACTION_SERVICE = 'Custom Service',
  LOOKUP_OUTPUT_MAPPING = 'Output Mapping',
  PAGE_FIELDS = 'Fields',
  WORKFLOW_MAIL_ROLES = 'Workflow Mail Roles',
  WORKFLOW_MAIL_FIELDS = 'Workflow Mail Fields',
  WORKFLOW_INITIAL_STATE = 'Initial State',
  WORKFLOW_ACTION_CONDITIONAL = 'Action Conditional',
  LOOKUPTO_OUTPUT_MAPPING_FIELDS = 'Lookup Output Mapping',
  DATABASE = 'Database',
  LOOKUPTO_FOREIGNKEY = 'Lookup To Foreignkey',
  LOOKUP_DEFINITION = 'Lookup Definition',
  LOOKUP_DEFINITION_SERVICE = 'Lookup Service',
  LOOKUP_TEMPLATE_FILTERS = 'Input Filters',
  LOOKUP_TEMPLATE_INDICES = 'Index',
  LOOKUP_TEMPLATE_FIELDS = 'Output Fields',
  LOOKUP_TEMPLATE = 'Lookup Definition',
  LOOKUP_TEMPLATE_DISPLAY_FIELD = 'Lookup Template Display Field',
  APP_NAVIGATION = 'App Navigation',
  LEFT_MENU = 'Left Menu',
  LIST_VIEW = 'List',
  UNIQUE_FOR_LOOKUP = 'Unique Fields For Lookup',
  DETAIL_PAGE_MAPPING = 'Detail Page Mapping',
  DETAIL_PAGE_MAPPING_SOURCE_FIELD = 'Map Detail View Parameters',
  DETAIL_PAGE_MAPPING_TARGET_FIELD = 'Map Detail View Parameters',
  QUERY_VIEW_MAPPING = 'Query view Mapping',
  QUERY_VIEW_MAPPING_SOURCE_FIELD = 'Query view Mapping',
  QUERY_VIEW_MAPPING_TARGET_FIELD = 'Query view Mapping',
  QUERYVIEW_CUD_CONFIGURATION = 'Query View Action configuration',
  DEFAULT_FILTER_PAGE_VARIABLE = 'Page Variables',
  QUERY_FILTERS = 'Fields for Unique Record for Lookup',
  QUERY_MANDATORY_FILTERS = 'Mandatory Input Parameters',
  QUERY_OPTIONAL_FILTERS = 'Optional Input Parameters',
  PAGES_INPUT_MAPPING = 'Input Mapping',
  PAGES_INPUT_MAPPING_SOURCE_FIELD = 'Input Mapping',
  PAGES_INPUT_MAPPING_TARGET_FIELD = 'Input Mapping',
  PAGES_OUTPUT_MAPPING = 'Output Mapping',
  PAGES_OUTPUT_MAPPING_SOURCE_FIELD = 'Output Mapping',
  PAGES_OUTPUT_MAPPING_TARGET_FIELD = 'Output Mapping',
  LOOKUP_TO_QUERYVIEW = 'Lookup to Query View',
  QUERY_VIEW = 'Query View',
  FOREIGN_KEY_PARENT_CHILD_TABLE = 'Foreign Key Parent-Child Table',
  DEFAULT_FILTER = 'Default Filtering Criteria',
  STANDARD_DATAGRID = 'Standard Datagrid',
  PARAMETER_MAPPING = 'Parameter Mapping',
  PARAMETER_MAPPING_SOURCE_FIELD = 'Data Grid Mapping',
  PARAMETER_MAPPING_TARGET_FIELD = 'Data Grid Mapping',
  LOOKUP_TEMPLATE_DISPLAY_FIELD_FOR_QUERY = 'Lookup Template Display Fields',
  RUNTIME_SHARED_FIELDS = 'Runtime Configurations - Runtime Field Sharing - Configure - Fields Shared',
  RUNTIME_VISIBILITY_OVERRIDE = 'Runtime Configurations - Runtime Field Sharing - Configure - Allow overriding of Field Properties',
  RUNTIME_VALUE_OVERRIDE = 'Runtime Configurations - Runtime Field Sharing - Configure - Allow overiding of Field Values',
  RUNTIME_STATUS_FIELD = 'Runtime Configurations - Workflow - Workflow Status Field',
  DETAIL_VIEW_PARAMS_MAPPING = 'Map Detail View Parameters',
  DETAIL_VIEW_PARAMS_MAPPING_SOURCE_FIELD = 'Detail View Mapping',
  DETAIL_VIEW_PARAMS_MAPPING_TARGET_FIELD = 'Detail View Mapping',
  HOLD_VALUE_PARAMS_MAPPING = 'Hold Values from List View for Record Creation',
  HOLD_VALUE_PARAMS_MAPPING_SOURCE_FIELD = 'Hold Values from List View for Record Creation',
  HOLD_VALUE_PARAMS_MAPPING_TARGET_FIELD = 'Hold Values from List View for Record Creation',
  GRID_COLUMN_NAVIGATION_PAGE = 'Detail page',
  CUD_CONFIGURATION = 'Query View Action configuration',
  CUD_TABLE_MAPPING = 'Query View Action Configuration - Step 1',
  CUD_QUERY_VIEW_FIELD_MAPPING = 'Query View Action Configuration - Step 2',
  CUD_FIELD_MAPPING = 'Query View Action Configuration - Step 2',
  PARAMETER_MAPPING_QUERY_VIEW = 'Parameter Mapping',
  PARAMETER_MAPPING_QUERY_VIEW_SOURCE_FIELD = 'Parameter Mapping',
  PARAMETER_MAPPING_QUERY_VIEW_TARGET_FIELD = 'Parameter Mapping',
  QUICK_FILTER_INPUT_MAPPING = 'Lookup Input Mapping',
  TBL_SEARCH_INPUT_MAPPING = 'Lookup Input Mapping',
  FORM_FIELD_INPUT_MAPPING = 'Lookup Input Mapping',
  QUICK_FILTER_OUTPUT_MAPPING = 'Output Mapping',
  TBL_SEARCH_OUTPUT_MAPPING = 'Output Mapping',
  FORM_FIELD_OUTPUT_MAPPING = 'Output Mapping',
  EMBEDDED_QUERY_VIEW_MAPPING = 'Query view Mapping',
  QUERY_DETAIL_PAGE_MAPPING = 'Detail Page Mapping',
  STANDARD_GRID_PARAMETER_MAPPING = 'Data Grid Mapping',
  QUERY_HOLD_VIEW_VALUES = 'Pass Values/Hold List View Values for Record Creation',
  QUERY_DETAIL_VIEW_MAPPING = 'Map Detail View Parameters',
  QUERY_PARAMETER_MAPPING = 'Parameter Mapping',
  DETAIL_PAGE_PARAMETERS = 'Pass Values to Detail Page',
  DETAIL_PAGE_PARAMETERS_SOURCE_FIELD = 'Pass Values to Detail Page',
  DETAIL_PAGE_PARAMETERS_TARGET_FIELD = 'Pass Values to Detail Page',
  QUERY_VIEW_MAPPING_PAGE_VARIABLES = 'Query view Mapping for Page Variables',
  QUERY_VIEW_MAPPING_PAGE_VARIABLES_SOURCE_FIELD = 'Query view Mapping for Page Variables',
  QUERY_VIEW_MAPPING_PAGE_VARIABLES_TARGET_FIELD = 'Query view Mapping for Page Variables',
  STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES = 'Data grid Parameter Mapping for Page Variables',
  STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES_SOURCE_FIELD = 'Data grid Mapping for Page Variables',
  STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES_TARGET_FIELD = 'Data grid Mapping for Page Variables',
  NAVIGATION_DATA_MAPPING = 'Pass Values to the Navigated Page',
  RULE_FIELD_VALUE = 'Rule Field Value',
  FOREIGN_KEY_PARENT_FIELDS = 'Foreign Key Parent Fields',
  NAVIGATION_DATA_MAPPING_SOURCE_FIELD = 'Pass Values to the Navigated Page',
  NAVIGATION_DATA_MAPPING_TARGET_FIELD = 'Pass Values to the Navigated Page',
  QUERY_DETAIL_PAGE = 'Query View Detail Page',
  EXECUTE_ON_FIELD_MAPPING = 'Execute On Field Mapping',
  EXECUTE_ON_PAGE_VARIABLE_MAPPING = 'Execute On Page Variable Mapping',
  RULE_SOURCE_FIELD = 'Rule Source Field',
  RULE_TARGET_FIELD = 'Rule Target Field',
  DEFAULT_FILTER_SOURCE_FIELD = 'Default Filter Source Field',
  TABLE_LOOKUP_DEFINITION = 'Table Lookup Definition',
  PROVIDER_BASE_URL = 'Base URL',
  CONFIGURATION_KEY_ENVIRONMENT = 'Environment Value',
  RECORD_IDENTIFIER_INDEX = 'Record Identifier Key'
}

export const ComponentType = {
  dataModel: 'Data Model',
  pages: 'Pages',
  workflow: 'Workflow',
  roles: 'Roles',
  customComponent: 'Custom Component',
  themes: 'Themes',
  appSettings: 'App Settings',
  service: 'Service',
  template: 'Template',
  queryBuilder: 'Query Builder',
  userStories: 'User Stories',
  apis: 'APIs',
  database: 'Database',
  queryString: 'Query String'
};

export enum ModelType {
  TABLE_GROUP = 'TABLE_GROUP',
  TABLE = 'TABLE',
  FIELD = 'FIELD',
  FIELD_GROUP = 'FIELD_GROUP',
  PAGES = 'PAGES',
  PAGE = 'PAGE',
  PAGE_VARIABLE = 'PAGE_VARIABLE',
  TABLE_ACL = 'TABLE_ACL',
  ROLE = 'ROLE',
  WORKFLOW = 'WORKFLOW',
  CUSTOM_COMPONENT = 'CUSTOM_COMPONENT',
  THEMES = 'THEMES',
  TECHNOLOGY_CHOICES = 'TECHNOLOGY_CHOICES',
  APP_SETTINGS = 'APP_SETTINGS',
  APP = 'APP',
  ORGANZIATION = 'ORGANZIATION',
  ENVIRONMENT = 'ENVIRONMENT',
  INDEX = 'INDEX',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
  LOOKUP = 'LOOKUP',
  FPK = 'FPK',
  MANDATORY_INPUT_FILTERS = 'MANDATORY_INPUT_FILTERS',
  OPTIONAL_FILTER = 'OPTIONAL_FILTER',
  LOOKUP_TO = 'LOOKUP_TO',
  LOOKUPTO_OUTPUT_MAPPING = 'LOOKUPTO_OUTPUT_MAPPING',
  LOOKUPTO_FILTER_INPUT_MAPPING = 'LOOKUPTO_FILTER_INPUT_MAPPING',
  SERVICE = 'SERVICE',
  DISPLAY_FIELD = 'DISPLAY_FIELD',
  WORKFLOW_ACTOR = 'WORKFLOW_ACTOR',
  WORKFLOW_ACTION = 'WORKFLOW_ACTION',
  FOREIGN_KEY = 'FOREIGN_KEY',
  FIELD_VALUE = 'FIELD_VALUE',
  UNIQUE_FIELDS_FOR_LOOKUP = 'UNIQUE_FIELDS_FOR_LOOKUP',
  LOOKUP_TEMPLATE = 'LOOKUP_TEMPLATE',
  INDEX_DEFINITION = 'INDEX_DEFINITION',
  RUNTIME_CONFIGURATION = 'RUNTIME_CONFIGURATION',
  QUERY_BUILDER = 'QUERY_BUILDER',
  EXPOSURE = 'EXPOSURE',
  BQ_DATASET = 'BQ_DATASET',
  SEARCHABLE_INDEX_FIELD = 'SEARCHABLE_INDEX_FIELD',
  ACL_CUSTOM_ACTION = 'ACL_CUSTOM_ACTION',
  CLIENT = 'CLIENT'
}

export enum UiActions {
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  RENAME = 'RENAME'
}

export enum ActionType {
  // Foreign Key related action types
  FOREIGN_KEY_DELETE = 'FOREIGN_KEY_DELETE',
  FOREIGN_KEY_INDEX_CHANGE = 'FOREIGN_KEY_INDEX_CHANGE',
  FOREIGN_KEY_FIELD_UPDATE = 'FOREIGN_KEY_FIELD_UPDATE',
  FOREIGN_KEY_FIELD_REMOVE = 'FOREIGN_KEY_FIELD_REMOVE',
  FOREIGN_KEY_PARENT_FIELD_REMOVE = 'FOREIGN_KEY_PARENT_FIELD_REMOVE',
  TRANSIENT_FIELD_IN_FOREIGN_KEY = 'TRANSIENT_FIELD_IN_FOREIGN_KEY',
  FOREIGN_KEY_RENAME = 'FOREIGN_KEY_RENAME',

  // Index designer related action types
  INDEX_DELETE = 'INDEX_DELETE',
  INDEX_FIELD_REMOVE = 'INDEX_FIELD_REMOVE',
  INDEX_UPDATE_TO_SECONDARY = 'INDEX_UPDATE_TO_SECONDARY',
  INDEX_UPDATE = 'INDEX_UPDATE',
  INDEX_RENAME = 'INDEX_RENAME',

  // Lookup template related action types
  LOOKUP_DELETE = 'LOOKUP_DELETE',
  REMOVE_FROM_QUERY_FILTERS = 'REMOVE_FROM_QUERY_FILTERS',
  LOOKUP_RENAMED = 'LOOKUP_RENAMED',
  LOOKUP_INDEX_CHANGE = 'LOOKUP_INDEX_CHANGE',
  LOOKUP_FIELD_UPDATE = 'LOOKUP_FIELD_UPDATE',
  LOOKUP_OUTPUT_FIELD_REMOVE = 'LOOKUP_OUTPUT_FIELD_REMOVE',
  LOOKUP_DISPLAY_PARENT_FIELD_REMOVE = 'LOOKUP_DISPLAY_PARENT_FIELD_REMOVE',
  LOOKUP_DISPLAY_CHILD_FIELD_REMOVE = 'LOOKUP_DISPLAY_CHILD_FIELD_REMOVE',
  LOOKUP_INPUT_FIELD_REMOVE = 'LOOKUP_INPUT_FIELD_REMOVE',
  LOOKUP_DISPLAY_FIELD_FOR_QUERY_REMOVE = 'LOOKUP_DISPLAY_FIELD_FOR_QUERY_REMOVE',
  TRANSIENT_FIELD_IN_LOOKUP = 'TRANSIENT_FIELD_IN_LOOKUP',

  // Runtime configuration related action types
  RUNTIME_WORKFLOW_DELETE = 'RUNTIME_WORKFLOW_DELETE',
  RUNTIME_SHARED_FIELD_REMOVE = 'RUNTIME_SHARED_FIELD_REMOVE',
  RUNTIME_VISIBILITY_OVERRIDE_FIELD_REMOVE = 'RUNTIME_VISIBILITY_OVERRIDE_FIELD_REMOVE',
  RUNTIME_VALUE_OVERRIDE_FIELD_REMOVE = 'RUNTIME_VALUE_OVERRIDE_FIELD_REMOVE',

  // ================== DataModel (Field / Table) related action types (Start)==================
  // FIELD_TYPE_UPDATE: Fallback when no specialized from/to rule applies OR no actual change.
  FIELD_TYPE_UPDATE = 'FIELD_TYPE_UPDATE',
  // Applied when previous type token normalizes to DROPDOWN and target is specialized (AUTONUMBER, CHECKBOX, COLOR, FILE_ATTACHMENT, IMAGE, RADIO, YESORNO, BOOLEAN)
  FIELD_TYPE_UPDATE_FROM_DROPDOWN = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_AUTONUMBER = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_AUTONUMBER',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_CHECKBOX = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_CHECKBOX',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_COLOR = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_COLOR',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_FILE_ATTACHMENT = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_FILE_ATTACHMENT',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_IMAGE = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_IMAGE',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_RADIO = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_RADIO',
  FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_YESORNO = 'FIELD_TYPE_UPDATE_FROM_DROPDOWN_TO_YESORNO',
  // Applied when previous type token normalizes to FORMULA_TYPE OR (Number/Double/Currency) and target is one of specialized targets
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_AUTONUMBER = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_AUTONUMBER',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_CHECKBOX = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_CHECKBOX',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_COLOR = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_COLOR',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_FILE_ATTACHMENT = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_FILE_ATTACHMENT',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_IMAGE = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_IMAGE',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_YESORNO = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_YESORNO',
  FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_RADIO = 'FIELD_TYPE_UPDATE_FROM_FORMULA_TYPE_TO_RADIO',
  // Applied when previous type is NOT DROPDOWN or FORMULA_TYPE family, but target is a specialized type token
  FIELD_TYPE_UPDATE_TO_AUTONUMBER = 'FIELD_TYPE_UPDATE_TO_AUTONUMBER',
  FIELD_TYPE_UPDATE_TO_BOOLEAN = 'FIELD_TYPE_UPDATE_TO_BOOLEAN',
  FIELD_TYPE_UPDATE_TO_CHECKBOX = 'FIELD_TYPE_UPDATE_TO_CHECKBOX',
  FIELD_TYPE_UPDATE_TO_COLOR = 'FIELD_TYPE_UPDATE_TO_COLOR',
  FIELD_TYPE_UPDATE_TO_FILE_ATTACHMENT = 'FIELD_TYPE_UPDATE_TO_FILE_ATTACHMENT',
  FIELD_TYPE_UPDATE_TO_IMAGE = 'FIELD_TYPE_UPDATE_TO_IMAGE',
  FIELD_TYPE_UPDATE_TO_YESORNO = 'FIELD_TYPE_UPDATE_TO_YESORNO',
  FIELD_TYPE_UPDATE_TO_RADIO = 'FIELD_TYPE_UPDATE_TO_RADIO',
  // Field / Formula / Property
  ALLOWED_VALUE_REMOVE = 'ALLOWED_VALUE_REMOVE',
  FIELD_VALUE_DELETE = 'FIELD_VALUE_DELETE',
  FIELD_DELETE = 'FIELD_DELETE',
  FIELD_FORMULA_BUILDER_FIELD_REMOVE = 'FIELD_FORMULA_BUILDER_FIELD_REMOVE',
  FIELD_PROPERTY_UPDATE_TO_TRANSIENT = 'FIELD_PROPERTY_UPDATE_TO_TRANSIENT',
  FIELD_RENAME = 'FIELD_RENAME',
  FORMULA_BUILDER_UPDATE = 'FORMULA_BUILDER_UPDATE',
  MANDATORY_FIELD_REMOVE = 'MANDATORY_FIELD_REMOVE',
  MANDATORY_FIELD_UPDATE = 'MANDATORY_FIELD_UPDATE',
  OPTIONAL_FIELD_REMOVE = 'OPTIONAL_FIELD_REMOVE',
  OPTIONAL_FIELD_UPDATE = 'OPTIONAL_FIELD_UPDATE',
  REMOVE_PID_FIELD = 'REMOVE_PID_FIELD',
  UNIQUE_FIELD_REMOVE = 'UNIQUE_FIELD_REMOVE',
  // Table related
  TABLE_TYPE_UPDATE_TO_ANALYTICAL = 'TABLE_TYPE_UPDATE_TO_ANALYTICAL',
  TABLE_TYPE_UPDATE_TO_COMPOSITE = 'TABLE_TYPE_UPDATE_TO_COMPOSITE',
  TABLE_TYPE_UPDATE_TO_TRANSIENT = 'TABLE_TYPE_UPDATE_TO_TRANSIENT',
  TABLE_DELETE = 'TABLE_DELETE',
  PARENT_TABLE_REMOVE = 'PARENT_TABLE_REMOVE',
  TABLE_TYPE_UPDATE_FROM_COMPOSITE = 'TABLE_TYPE_UPDATE_FROM_COMPOSITE',
  TRANSACTION_TABLE_REMOVE = 'TRANSACTION_TABLE_REMOVE',
  EXPORT_FIELDS_REMOVE = 'EXPORT_FIELDS_REMOVE',
  EXPORT_FILTERS_REMOVE = 'EXPORT_FILTERS_REMOVE',
  IMPORT_FIELDS_REMOVE = 'IMPORT_FIELDS_REMOVE',
  TABLE_TYPE_UPDATE = 'TABLE_TYPE_UPDATE',
  TABLE_UNIQUE_FIELD_REMOVE = 'TABLE_UNIQUE_FIELD_REMOVE',
  TABLE_MANDATORY_FIELD_REMOVE = 'TABLE_MANDATORY_FIELD_REMOVE',
  TABLE_OPTIONAL_FIELD_REMOVE = 'TABLE_OPTIONAL_FIELD_REMOVE',
  TABLE_DATASET_REMOVE = 'TABLE_DATASET_REMOVE',
  PARENT_TABLE_UPDATE = 'PARENT_TABLE_UPDATE',
  // Query view related
  DISABLE_DEFAULT_ROW_DETAIL_PAGE = 'DISABLE_DEFAULT_ROW_DETAIL_PAGE',
  UPDATE_QUERY_TYPE_FROM_SINGLE = 'UPDATE_QUERY_TYPE_FROM_SINGLE',
  UPDATE_QUERY_TYPE_FROM_MULTIPLE = 'UPDATE_QUERY_TYPE_FROM_MULTIPLE',
  // ================== DataModel (Field / Table) related action types (End)==================

  // Page Variable related action types
  PAGE_VARIABLE_DELETE = 'PAGE_VARIABLE_DELETE',
  PAGE_VARIABLE_TYPE_UPDATE = 'PAGE_VARIABLE_TYPE_UPDATE',

  // ================== Table ACL related action types ==================
  TABLE_ACL_CUSTOM_ACTION_DELETE = 'TABLE_ACL_CUSTOM_ACTION_DELETE',
  TABLE_ACL_CUSTOM_ACTION_RENAME = 'TABLE_ACL_CUSTOM_ACTION_RENAME',
  TABLE_ACL_UPDATE = 'TABLE_ACL_UPDATE',
  TABLE_ACL_DELETE = 'TABLE_ACL_DELETE',

  // ================== Query Builder related action types ==================
  QUERY_BUILDER_ROLE_REMOVE = 'QUERY_BUILDER_ROLE_REMOVE',
  QUERY_BUILDER_FIELD_VALUE_REMOVE = 'QUERY_BUILDER_FIELD_VALUE_REMOVE',
  QUERY_BUILDER_SOURCE_FIELD_REMOVE = 'QUERY_BUILDER_SOURCE_FIELD_REMOVE',
  QUERY_BUILDER_TARGET_FROM_FIELD_REMOVE = 'QUERY_BUILDER_TARGET_FROM_FIELD_REMOVE',
  QUERY_BUILDER_TARGET_TO_FIELD_REMOVE = 'QUERY_BUILDER_TARGET_TO_FIELD_REMOVE',
  QUERY_BUILDER_TARGET_FIELD_REMOVE = 'QUERY_BUILDER_TARGET_FIELD_REMOVE',

  // ================== Exposed REST APIs related action types ==================
  EXPOSURE_SERVICE_RENAME = 'EXPOSURE_SERVICE_RENAME',
  EXPOSURE_DELETE = 'EXPOSURE_DELETE',
  EXPOSURE_CONTEXT_PATH_RENAME = 'EXPOSURE_CONTEXT_PATH_RENAME',
  CLIENT_DELETE = 'CLIENT_DELETE',

  // ================== Custom Component related action types ==================
  CUSTOM_COMPONENT_DELETE = 'CUSTOM_COMPONENT_DELETE',

  // ================== Page (Screens) related action types ==================
  PAGE_DELETE = 'PAGE_DELETE',
  PAGE_RENAME = 'PAGE_RENAME',

  // ================== Role related action types ==================
  ROLE_DELETE = 'ROLE_DELETE',
  ROLE_SHORTNAME_RENAME = 'ROLE_SHORTNAME_RENAME',

  // ================== Workflow related action types ==================
  WORKFLOW_ACTION_DELETE = 'WORKFLOW_ACTION_DELETE',
  WORKFLOW_DELETE = 'WORKFLOW_DELETE',
  WORKFLOW_ACTOR_DELETE = 'WORKFLOW_ACTOR_DELETE',

  // ================== Searchable Index related action types ==================
  SEARCHABLE_DELETE = 'SEARCHABLE_DELETE',

  // ================== Technology Stack related action types ==================
  DATA_SET_DELETE = 'DATA_SET_DELETE',

  // ================== Environment related action types ==================
  ENVIRONMENT_DELETE = 'ENVIRONMENT_DELETE',
  ENVIRONMENT_UPDATE = 'ENVIRONMENT_UPDATE',

  // ================== Lifecycle related action types ==================
  CONTEXT_PATH_RENAMED = 'CONTEXT_PATH_RENAMED',

  // ================== Querystring related action types ==================
  QUERY_STRING_DELETE = 'QUERY_STRING_DELETE'
}

export enum ReferenceWarningProperty {
  FORMULA_BUILDER = 'FORMULA_BUILDER',
  FOREIGN_KEY_FIELDS = 'FOREIGN_KEY_FIELDS',
  INDEX = 'INDEX',
  LOOKUP_TEMPLATE_DISPLAY_FIELD = 'LOOKUP_TEMPLATE_DISPLAY_FIELD',
  LOOKUP_TEMPLATE_FIELDS = 'LOOKUP_TEMPLATE_FIELDS',
  LOOKUP_TEMPLATE_FILTERS = 'LOOKUP_TEMPLATE_FILTERS',
  DETAIL_PAGE_MAPPING = 'DETAIL_PAGE_MAPPING',
  DETAIL_PAGE_MAPPING_SOURCE_FIELD = 'DETAIL_PAGE_MAPPING_SOURCE_FIELD',
  DETAIL_PAGE_MAPPING_TARGET_FIELD = 'DETAIL_PAGE_MAPPING_TARGET_FIELD',
  QUERY_VIEW_MAPPING = 'QUERY_VIEW_MAPPING',
  QUERY_VIEW_MAPPING_SOURCE_FIELD = 'QUERY_VIEW_MAPPING_SOURCE_FIELD',
  QUERY_VIEW_MAPPING_TARGET_FIELD = 'QUERY_VIEW_MAPPING_TARGET_FIELD',
  PAGES_INPUT_MAPPING = 'PAGES_INPUT_MAPPING',
  PAGES_INPUT_MAPPING_SOURCE_FIELD = 'PAGES_INPUT_MAPPING_SOURCE_FIELD',
  PAGES_INPUT_MAPPING_TARGET_FIELD = 'PAGES_INPUT_MAPPING_TARGET_FIELD',
  PAGES_OUTPUT_MAPPING = 'PAGES_OUTPUT_MAPPING',
  PAGES_OUTPUT_MAPPING_SOURCE_FIELD = 'PAGES_OUTPUT_MAPPING_SOURCE_FIELD',
  PAGES_OUTPUT_MAPPING_TARGET_FIELD = 'PAGES_OUTPUT_MAPPING_TARGET_FIELD',
  DEFAULT_FILTER = 'DEFAULT_FILTER',
  PARAMETER_MAPPING = 'PARAMETER_MAPPING',
  HOLD_VALUE_PARAMS_MAPPING = 'HOLD_VALUE_PARAMS_MAPPING',
  HOLD_VALUE_PARAMS_MAPPING_SOURCE_FIELD = 'HOLD_VALUE_PARAMS_MAPPING_SOURCE_FIELD',
  HOLD_VALUE_PARAMS_MAPPING_TARGET_FIELD = 'HOLD_VALUE_PARAMS_MAPPING_TARGET_FIELD',
  DETAIL_VIEW_PARAMS_MAPPING = 'DETAIL_VIEW_PARAMS_MAPPING',
  DETAIL_VIEW_PARAMS_MAPPING_SOURCE_FIELD = 'DETAIL_VIEW_PARAMS_MAPPING_SOURCE_FIELD',
  DETAIL_VIEW_PARAMS_MAPPING_TARGET_FIELD = 'DETAIL_VIEW_PARAMS_MAPPING_TARGET_FIELD',
  PARAMETER_MAPPING_QUERY_VIEW = 'PARAMETER_MAPPING_QUERY_VIEW',
  PARAMETER_MAPPING_QUERY_VIEW_TARGET_FIELD = 'PARAMETER_MAPPING_QUERY_VIEW_TARGET_FIELD',
  PARAMETER_MAPPING_QUERY_VIEW_SOURCE_FIELD = 'PARAMETER_MAPPING_QUERY_VIEW_SOURCE_FIELD',
  CUD_FIELD_MAPPING = 'CUD_FIELD_MAPPING',
  CUD_QUERY_VIEW_FIELD_MAPPING = 'CUD_QUERY_VIEW_FIELD_MAPPING',
  RUNTIME_STATUS_FIELD = 'RUNTIME_STATUS_FIELD',
  RULE_SOURCE_FIELD = 'RULE_SOURCE_FIELD',
  RULE_TARGET_FIELD = 'RULE_TARGET_FIELD',
  RULE_FIELD_VALUE = 'RULE_FIELD_VALUE',
  FOREIGN_KEY_PARENT_FIELDS = 'FOREIGN_KEY_PARENT_FIELDS',
  QUERY_STRING = 'QUERY_STRING',
  PROVIDER_BASE_URL = 'PROVIDER_BASE_URL',
  CONFIGURATION_KEY_ENVIRONMENT = 'CONFIGURATION_KEY_ENVIRONMENT'
}
